import ElementUI from 'element-ui'
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}
export const scrollTo = (target, wrapDom = null) => {
  let wrapper = wrapDom || document.documentElement;
  let top = parseInt( wrapper.scrollTop);
  let dis = target - top;
  let intev = 10;
  let splice = dis / 30;

  let timer = window.setInterval(() => {
    top = top + splice;;
    wrapper.scrollTop = top;
    if (dis >= 0) {
      if (top >= target) {
        wrapper.scrollTop = target;
        window.clearInterval(timer);
      }
    }
    if (dis <= 0) {
      if (top <= target) {
        wrapper.scrollTop = target;
        window.clearInterval(timer);
      }
    }
  }, intev)
}
export const isIE = () => {
  if (!!window.ActiveXObject || "ActiveXObject" in window) {
    return true;
  } else {
    return false;
  }
}
export const getRandom = (m, n) => Math.floor(Math.random() * (m - n) + n)
export const debounce = (fn, delay = 200) => {
  let timer = null;
  return function() {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments)
    }, delay)
  }
}
export const copyObj = obj => JSON.parse(JSON.stringify(obj))
export const download = (data, filename, callback) =>{
  const blob = new Blob([data], { type: 'application/octet-stream' });
  if (typeof window.navigator.msSaveBlob !== 'undefined') {
    // 兼容IE，window.navigator.msSaveBlob：以本地方式保存文件
    window.navigator.msSaveBlob(blob, decodeURI(filename))
  } else {
    // 创建新的URL并指向File对象或者Blob对象的地址
    const blobURL = window.URL.createObjectURL(blob)
    // 创建a标签，用于跳转至下载链接
    const tempLink = document.createElement('a')
    tempLink.style.display = 'none'
    tempLink.href = blobURL
    tempLink.setAttribute('download', decodeURI(filename))
    // 兼容：某些浏览器不支持HTML5的download属性
    if (typeof tempLink.download === 'undefined') {
      tempLink.setAttribute('target', '_blank')
    }
    // 挂载a标签
    document.body.appendChild(tempLink)
    tempLink.click()
    document.body.removeChild(tempLink)
    // 释放blob URL地址
    window.URL.revokeObjectURL(blobURL)
    callback && callback();
  }
}
export const fileInfo = file => {
  if(typeof file === 'string') return { name: file, url: file }
  else if(typeof file === 'object' && file != null) return { name: file.name || file.url, url: file.url }
  else return {}
}
const fileKeys = ['file_code', 'file_part_content', 'name', 'url'];
export const transFileObjToCode = (data) => {
  if(Array.isArray(data)){
    return data.map(item => transFileObjToCode(item))
  }else if(typeof data === 'object' && data instanceof Object){
    let keys = Object.keys(data);
    if(keys.length === 4 && 
      keys.every(item => fileKeys.indexOf(item) != -1)){
      return data.file_code;
    }else{
      let result = {};
      keys.forEach(key => {
        result[key] = transFileObjToCode(data[key])
      })
      return result;
    }
  }
  return data;
}
export const getObjByName = (name, data = null) => {
  let object = data == null ? this : data;
  let split = name.split('.');
  if(split.length > 1){
    let [ key ] = split;
    let newName = split.slice(1, split.length).join('.');
    return this.getObjByName(newName, object[key])
  }else{
    return object[name];
  }
}
export const ALink = (url, target = '_blank') => setTimeout(() => window.open(url, target))
export const requiredRule = {required: true, message: '该项不能为空', trigger: 'blur' };
export const label = (option, param, symbol = ' - ') => {
  if(!option || !param)
    return option['label'];
  let arr = param.split(',');
  return arr.map(item => {
    let [ v1, v2 ] = item.split('|');
    if(!option[v1] && !option[v2])
      return null;
    return option[v1] || option[v2];
  }).filter(item => item != null).join(symbol)
}
export const isImage = url => {
  if(!url) return false;
  let index = url.lastIndexOf('.')
  let suffix = index != -1 ? url.substr(index + 1) : url;
  let accept = ['xbm','tif','pjp','svgz','jpg','jpeg','ico','tiff','gif','svg','jfif','webp','png','bmp','pjpeg','avif'];
  return suffix && accept.indexOf(suffix.toLowerCase()) != -1
}
export const copyText = data => {
  let oInput = document.createElement("input");
  oInput.value = data;
  oInput.readOnly="readOnly";
  document.body.appendChild(oInput);
  oInput.select();
  oInput.setSelectionRange(0, data.length);
  document.execCommand("Copy");
  oInput.className = "oInput";
  oInput.style.display = "none";
  ElementUI.Message({
    message: '复制成功',
    type: 'success'
  })
}
export const getObjDeepVal = (obj, str) => {
  let result = undefined;
  let splits = str.split('.');
  let parentObj = null;
  splits.forEach(item => {
    result = parentObj
    ? parentObj[item]
    : obj[item]
    parentObj = result
  })
  return result
}
/**
 * @param {Blob} data 
 * @param {string} filename 
 */
export const downloadFile = (data, filename) => {
  const blob = new Blob([data], { type: 'application/octet-stream' });
  // 创建新的URL并指向File对象或者Blob对象的地址
  const blobURL = window.URL.createObjectURL(blob)
  // 创建a标签，用于跳转至下载链接
  const tl = document.createElement('a')
  tl.style.display = 'none'
  tl.href = blobURL
  tl.setAttribute('download', decodeURI(filename))
  // 兼容：某些浏览器不支持HTML5的download属性
  if (typeof tl.download === 'undefined')
    tl.setAttribute('target', '_blank')
  // 挂载a标签
  document.body.appendChild(tl)
  tl.click()
  document.body.removeChild(tl)
  // 释放blob URL地址
  window.URL.revokeObjectURL(blobURL)
}




// WEBPACK FOOTER //
// ./src/utils/index.js